import { NotePencilIcon } from '@fronton/icons-react';
import {
  DesignRegistrationPanelStructure,
  PanelActionBlock,
} from 'common/components/design-registration-panel';

export const FENCES_PANEL_ACTION_BLOCK: PanelActionBlock = {
  elementBlock: '',
  label: 'Записаться на консультацию',
  variant: 'accent',
};

export const FENCES_PANEL_STRUCTURE: DesignRegistrationPanelStructure = {
  panel: {
    content: {
      leftIcon: NotePencilIcon,
      iconColor: 'text-invert',
      iconType: 'outline',
      text: 'Запишитесь на\u00A0консультацию и\u00A0расчёт',
    },
    actionBlock: [],
  },
  mobilePanel: {
    mobileButton: {
      elementBlock: '',
      label: 'Записаться на консультацию',
    },
    content: {
      icon: NotePencilIcon,
      iconColor: 'text-invert',
      iconType: 'duotone',
      text: 'Запишитесь на\u00A0консультацию и\u00A0расчёт',
    },
    actionBlock: [],
  },
};
